import React, { useState } from "react";
import "../Accountsignup/Accountsignup.scss";
import FormInputs from "../FormInputs/FormInputs";
import { useNavigate } from "react-router-dom";
import Button from "../Button";
import { passwordRegex } from "../../services/Regex";

const initialValue = {
  password: "",
  confirmPassword: "",
};

const Password = ({ registerData, setRegisterData, onNext, onBack }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState(initialValue);
  const handleNav = () => {
    navigate("/");
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegisterData({
      ...registerData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateFields = () => {
    let errObj = { ...initialValue };
  
    if (!registerData.password) {
      errObj.password = "Password is required";
    } else if (!passwordRegex.test(registerData.password)) {
      errObj.password = "Password must be at least 8 characters including 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number";
    } else {
      errObj.password = "";
    }
  
    if (!registerData.confirmPassword) {
      errObj.confirmPassword = "Confirm Password is required";
    } else if (!passwordRegex.test(registerData.confirmPassword)) {
      errObj.confirmPassword = "Password must be at least 8 characters including 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number";
    } else if (registerData.confirmPassword !== registerData.password) {
      errObj.confirmPassword = "Passwords do not match";
    } else {
      errObj.confirmPassword = "";
    }
  
    setErrors(errObj);
    const data = Object.values(errObj).every((x) => x === "" || x === null);
    return data;
  };
  
  const handleCheckError = () => {
    if (validateFields()) onNext();
  };

  return (
    <div className="account">
      <div className="account_box">
        <div className="account_box_header">
          <div className="account_box_header_heading">
            <h1>Create Account</h1>
          </div>
          <div
            className="account_box_header_text u_cursor_pointer"
            onClick={handleNav}
          >
            <p>
              Already have an account? <span>Login</span>
            </p>
          </div>
          <div className="account_box_header_content">
            <div className="account_box_header_content_inputs">
              <FormInputs
                title="Create password"
                type={"password"}
                placeholder="Enter your password"
                name="password"
                value={registerData?.password}
                onChange={handleChange}
                error={errors?.password}
              />
            </div>
            <div className="account_box_header_content_inputs">
              <FormInputs
                title="Confirm password"
                type={"password"}
                placeholder="Enter your password again"
                name="confirmPassword"
                value={registerData?.confirmPassword}
                onChange={handleChange}
                error={errors?.confirmPassword}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="buttons">
        <Button
          disabled={!onBack}
          onClick={onBack}
        >
          &lt; Back
        </Button>
        <Button  onClick={handleCheckError}>
          Sign Up
        </Button>
      </div>
    </div>
  );
};

export default Password;
